import type { Route } from '../core/types';
import { isMotorwayStep, secondsToMotorway } from './bigRoads';
import { insideBangkok } from './trafficRegion';
import { paceDuration } from './paceModel';
import { planFerry } from './ferry';

export function expresswayAccess(route: Route): { metres: number; seconds: number } | null {
  let metres = 0;
  for (const step of route.legs.flatMap(leg => leg.steps)) {
    if (isMotorwayStep(step)) return { metres, seconds: secondsToMotorway(route) };
    metres += Math.max(0, step.distance);
  }
  return null;
}

export function quickestExpresswayIndex(routes: Route[]): number {
  let index = -1;
  let best = Infinity;
  routes.forEach((route, i) => {
    const access = expresswayAccess(route);
    if (access && access.seconds < best) { best = access.seconds; index = i; }
  });
  return index;
}

/** Prompt once for a meaningful Bangkok tradeoff within ten minutes. */
export function closeExpresswayChoice(routes: Route[], truck: boolean, now = Date.now()): [number, number] | null {
  const origin = routes[0]?.geometry.coordinates[0];
  if (routes.length < 2 || !origin || !insideBangkok(origin)) return null;
  const quickest = quickestExpresswayIndex(routes);
  if (quickest < 0) return null;
  const other = quickest === 0 ? 1 : quickest;
  const time = (route: Route) => paceDuration(route) + (planFerry(route, paceDuration(route), now, truck)?.waitSeconds ?? 0);
  if (Math.abs(time(routes[other]) - time(routes[0])) > 600) return null;
  const a = expresswayAccess(routes[0]);
  const b = expresswayAccess(routes[other]);
  if (a && b && Math.abs(a.metres - b.metres) < 250 && Math.abs(a.seconds - b.seconds) < 30) return null;
  if (a?.metres === 0 && b?.metres === 0) return null;
  return [0, other];
}
